import { EventManager } from '@proteo/core';
import Bowser from 'bowser';
import { navigateToUrl } from 'single-spa';
import { getPortalConfig } from './portal-services';

export class CheckNavigator {
  async checkNavigator(oldUrl: string): Promise<any> {
    const data = Bowser;
    if (typeof data !== 'undefined') {
      const uaParser = data.getParser(window.navigator.userAgent);
      const browserName = uaParser.getBrowserName();
      let redirect = false;

      const browserVersion = uaParser.getBrowserVersion() ? parseInt(uaParser.getBrowserVersion()) : 0;
      const osVersion = uaParser.getOSVersion() ? parseFloat(uaParser.getOSVersion()) : 0.0;
      const isTablet = /(ipad|linux|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        navigator.userAgent.toLowerCase()
      );

      if (uaParser.getPlatformType() === 'desktop') {
        this.redirectToQr(oldUrl);
      } else {
        if (
          (isTablet && window.matchMedia('(pointer: coarse)').matches && uaParser.getPlatformType() === 'desktop') ||
          uaParser.getPlatformType() !== 'desktop'
        ) {
          redirect =
            (browserName === 'Chrome' && browserVersion < 89) ||
            (browserName === 'Safari' && osVersion < 14.3) ||
            (browserName === 'Firefox' && browserVersion < 100) ||
            (browserName === 'Microsoft Edge' && browserVersion < 89) ||
            browserName === 'Internet Explorer' ||
            browserName === 'Opera Mobile' ||
            browserName === 'Miui';
        } else if (uaParser.getPlatformType() === 'desktop') {
          redirect = true;
        }
        if (redirect === true && !window.location.href.includes('error')) {
          EventManager.getInstance().publish('ERROR', { error: '7' });
        }
      }
    }
  }

  private redirectToQr(oldUrl: string) {
    // this.router.navigate([`${this.sharedConfig.commonMfeConfig.basePath}results-messages/qr/recoverOnline/recovery`]);
    // this.router.navigate([`${this.sharedConfig.commonMfeConfig.basePath}results-messages/qr/continueProcess`]);

    let url = '';
    if (oldUrl.includes('landing')) {
      url = 'results-messages/qr/continueProcess/landing';
    }
    if (oldUrl.includes('enrollment')) {
      url = 'results-messages/qr/continueProcess/enrollment';
    }
    if (oldUrl.includes('multiholder-selector')) {
      url = 'results-messages/qr/continueProcess/selector';
    }
    if (oldUrl.includes('recovery')) {
      url = 'results-messages/qr/recoverOnline/recovery';
    }

    url = '/' + getPortalConfig().CUSTOM_CONFIG.PORTAL_BASE_PATH + url;
    navigateToUrl(url);
  }
}
